/** What the page calls the model that grades. One word to change if the name changes. */
export const GRADER = 'AI grader';
